import moment from 'moment'
import {FaCheckCircle, FaTimesCircle, FaUserShield, FaGoogle, FaKey} from 'react-icons/fa'
import DeleteItemIcon from "../../../assets/delete-item.svg";
import EditItemIcon from "../../../assets/edit-item.svg";
import SortableTh from "../../shared/SortableTh";

const ViewUsers = ({
                       data,
                       sort,
                       order,
                       onSort,
                       editHandler,
                       deleteHandler,
                       isLoadingDelete,
                       canAssignRoles,
                       onEditRole,
                       canResetPassword,
                       onResetPassword,
                   }) => {
    return (
        <div className='table-responsive bg-light p-3 mt-2'>
            <table className='table table-sm table-border'>
                <thead className='border-0'>
                <tr>
                    <SortableTh label='Joined Date' field='createdAt' sort={sort} order={order} onSort={onSort}/>
                    <SortableTh label='Name' field='name' sort={sort} order={order} onSort={onSort}/>
                    <SortableTh label='Email' field='email' sort={sort} order={order} onSort={onSort}/>
                    <th>Login</th>
                    <th>Group</th>
                    <SortableTh label='Last Login' field='lastLoginAt' sort={sort} order={order} onSort={onSort}/>
                    <th>TelegramID</th>
                    {/*<th>Confirmed</th>*/}
                    <SortableTh label='Blocked' field='blocked' sort={sort} order={order} onSort={onSort}/>
                    <th>Actions</th>
                </tr>
                </thead>

                <tbody>
                {data &&
                    data.data.map((user) => (
                        <tr key={user._id}>
                            <td>{moment(user.createdAt).format('lll')}</td>
                            <td>{user.name}</td>
                            <td>
                                <a href={`mailto:${user.email}`}>{user.email}</a>
                            </td>
                            <td>
                                {user.provider === 'google'
                                    ? <span className='badge bg-light text-dark'><FaGoogle className='me-1'/>Google</span>
                                    : <span className='badge bg-light text-dark'><FaKey className='me-1'/>Password</span>}
                            </td>
                            <td>
                                {user.roles && user.roles.length > 0
                                    ? (
                                        <span className='d-flex flex-wrap gap-1'>
                                            {user.roles.map((role) => (
                                                <span key={role.assignmentId || role._id} className='badge bg-light text-dark'>
                                                    {role.name}
                                                </span>
                                            ))}
                                        </span>
                                    )
                                    : <span className='text-muted'>—</span>}
                            </td>
                            <td>
                                {user.lastLoginAt
                                    ? moment(user.lastLoginAt).format('lll')
                                    : 'Never'}
                            </td>
                            <td>{user.telegramId}</td>
                            {/*<td>*/}
                            {/*    {user.confirmed ? (*/}
                            {/*        <FaCheckCircle className='text-success'/>*/}
                            {/*    ) : (*/}
                            {/*        <FaTimesCircle className='text-danger'/>*/}
                            {/*    )}*/}
                            {/*</td>*/}
                            <td>
                                {user.blocked ? (
                                    <FaCheckCircle className='text-success'/>
                                ) : (
                                    <FaTimesCircle className='text-danger'/>
                                )}
                            </td>

                            <td>
                                <div className='btn-group'>
                                    {canAssignRoles && (
                                        <button
                                            className='btn'
                                            onClick={() => onEditRole(user)}
                                            data-bs-toggle='modal'
                                            data-bs-target='#userRoleAssignModal'
                                            title='Assign role'
                                        >
                                            <FaUserShield className='action-icons-img'/>
                                        </button>
                                    )}
                                    {canResetPassword && user.provider !== 'google' && (
                                        <button
                                            className='btn'
                                            onClick={() => onResetPassword(user)}
                                            data-bs-toggle='modal'
                                            data-bs-target='#userResetLinkModal'
                                            title='Reset password'
                                        >
                                            <FaKey className='action-icons-img'/>
                                        </button>
                                    )}
                                    <button
                                        className='btn'
                                        onClick={() => editHandler(user)}
                                        data-bs-toggle='modal'
                                        data-bs-target='#userModal'
                                    >
                                        <img src={EditItemIcon} alt="Edit"
                                             className="icon-img action-icons-img"/>
                                    </button>

                                    <button
                                        className='btn'
                                        onClick={() => deleteHandler(user._id)}
                                        disabled={isLoadingDelete}
                                    >
                                        {isLoadingDelete ? (
                                            <span className='spinner-border spinner-border-sm'/>
                                        ) : (
                                            <span>
                                                <img src={DeleteItemIcon} alt="Delete" className="icon-img action-icons-img"/>
                                            </span>
                                        )}
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default ViewUsers
